export const USER_ATTEMPTS_COLLECTION = "amount_of_using"
export const MAIN_CONSTANTS_COLLECTION = "main_constants"
export const MAIN_CONSTANTS_DOCUMENT = "receipt_constants"